{
  "ACTIONS": {
    "CONFIRM": "Megerősítés",
    "CONTINUE": "Folytatás",
    "SUBMIT": "Beküldés",
    "RETRY": "Újra",
    "CANCEL": "Visszavonás",
    "EMPTY": "Nincs megrendelése",
    "LOADING_ORDERS": "A számla előkészítése",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Kosár frissítése",
    "EDIT": "Szerkesztés",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "Ez a szekció már nem elérhető",
    "ITEM_NOT_FOUND": "Ez a tétel már nem elérhető",
    "PROMOTION_NOT_AVAILABLE": "Ez az akció már nem elérhető",
    "REQUIRED": "Required",
    "COMBO": "Kombó",
    "INVALID_EMAIL": "Kérjük, adjon meg érvényes e-mail-címet",
    "INVALID_PHONE": "Kérjük, adjon meg érvényes telefonszámot",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "Hiba történt az asztal betöltésekor. Kérjük, próbálja újra.",
    "TABLE_NOT_FOUND": "Nem találtuk ezt az asztalt. Kérjük, olvassa be újra a QR-kódot."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Vezetéknév",
    "ROOM_NUMBER": "Szoba száma",
    "SNACKBAR_TITLE": "A számlája hamarosan érkezik",
    "PAY_BILL": "Fizesse ki a számlát"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Az asztalnál ülők száma összesen",
    "PAYING_FOR": "Azok száma, akikért fizet",
    "REMAINING": "Fennmaradó összeg",
    "CHEQUE": "Számla",
    "AMOUNT_PAID": "Kifizetett összeg",
    "DISCOUNT": "Kedvezmény",
    "PROMO": "Promóció",
    "FEES": "Díjak",
    "PAID_ITEMS": "Kifizetett tételek",
    "SPLIT_BILL": "Számla felosztása",
    "EDIT_SPLIT": "Felosztás szerkesztése",
    "PAY_BILL": "Számla kifizetése",
    "SPLIT_TITLE": "A számla felosztása",
    "SPLIT_SUBTITLE": "Válassza ki, hogyan szeretné felosztani a számlát",
    "SPLIT_EVENLY": "Egyenlő felosztás",
    "CUSTOM_AMOUNT": "Egyéni összeg",
    "ADD_CUSTOM_AMOUNT": "Egyéni összeg hozzáadása",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Adja meg az egyéni összeget",
    "PAY_FOR_ITEMS": "Fizesse ki a saját tételeit",
    "CONFIRM_SELECTION": "Választás megerősítése",
    "SOMEONE_ELSE_PAYING": "Valaki más az asztalánál éppen fizet"
  },
  "COMBO": {
    "ADD_N": "{{count}} {{section}} hozzáadása",
    "REMOVE_N": "{{count}} {{section}} eltávolítása",
    "CANNOT_PROCEED": "A folytatás előtt kérjük, kövesse a fenti útmutatót a kombó befejezéséhez",
    "COMPLETE": "A(z) {{combo}} kombó kész!",
    "ON_ANOTHER_SECTION": "Ez a(z) {{section}} kombó része"
  },
  "CART": {
    "TITLE": "Kosár",
    "RECOMMENDATION": "Ez is tetszhet",
    "TOTAL": "Összesen",
    "VIEW": "Kosár megtekintése & Rendelje meg",
    "EMPTY": "Üres",
    "PLACE_ORDER": "Rendelje meg",
    "ADD_TO_BILL": "Hozzáadás a számlához",
    "PAY_NOW": "Fizetés most",
    "OOPS": "Hoppá",
    "ADD_NEW_VARIANT": "Másik hozzáadása",
    "VARIANT_TITLE": "Meggondolta magát?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "Fizetés",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "Rendeléseim",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "Összes",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Rendelés",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "A rendelése nincs kifizetve",
    "CANCELLED": "A rendelése törölve lett",
    "VOID": "A rendelése érvénytelenítve lett",
    "UPDATED": "A rendelése frissítve lett",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "Hamarosan Önnél vagyunk",
    "HELP": "Hogyan tudunk segíteni?",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "Kihagyás",
    "MENU": "Menü",
    "SEARCH": "Keresés",
    "NO_SEARCH_RESULTS": "Nincs a keresésnek megfelelő tétel",
    "SEARCH_OTHER_SECTIONS": "Más szekciókban is találtunk egyezéseket",
    "NO_FILTER_RESULTS": "Egy tétel sem felel meg a szűrőknek",
    "CLEAR_FILTERS": "Szűrők törlése",
    "NO_SECTIONS": "Nincsenek elérhető szekciók",
    "STAFF": "Személyzet",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "Beállítások",
    "LANGUAGE": "Nyelv",
    "SELECT_LANGUAGE": "Válasszon nyelvet",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Tegye a szobám számlájára"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "Adja meg a kuponját",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "Borravaló",
    "ADD": "Borravaló hozzáadása",
    "PLACEHOLDER": "Adja meg a borravaló összegét"
  },
  "LANDING": {
    "CALL_WAITER": "Pincér hívása",
    "VIEW_BILL": "Számla megtekintése - ",
    "LOADING_BILL": "Számla betöltése"
  },
  "LOADER": {
    "Heading": "Fizetés feldolgozása...",
    "Subheading": "Kérjük, ne zárja be ezt az oldalt. Megerősítjük a fizetést, és automatikusan átirányítjuk.",
    "Hint": "Ez általában néhány másodpercet vesz igénybe."
  },
  "NoVoucher": "A kupon nem elérhető",
  "VoucherDisabled": "Ez a kupon letiltva",
  "VoucherExpired": "Ez a kupon lejárt",
  "VoucherAlreadyUsed": "Ezt a kupont már felhasználták",
  "VoucherZeroBalance": "Ennek a kuponnak az egyenlege 0",
  "VoucherUserLimitReached": "Már felhasználta ezt a kupont",
  "VoucherFirstOrderOnly": "Ez a kupon csak az első rendeléséhez érvényes",
  "VoucherNotApplicable": "Ez a kupon nem vonatkozik a rendelésében szereplő tételekre"
}
